import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { IUnsubscribeCheckStatusResponse } from '@modules/unsubscribe/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { UNSUBSCRIBE_CHECK_STATUS_QUERY_KEY, UNSUBSCRIBE_CHECK_STATUS_URL } from '@modules/unsubscribe/constants';

export default function useUnsubscribeCheckStatusQuery(payload: Ref<string>): IContextQueryResult<IUnsubscribeCheckStatusResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IUnsubscribeCheckStatusResponse, Error>({
    queryKey: [UNSUBSCRIBE_CHECK_STATUS_QUERY_KEY, payload],
    queryFn: async ({ signal }) => fetchGet(UNSUBSCRIBE_CHECK_STATUS_URL, {
      signal,
      urlParams: {
        token: payload.value,
      },
    }),
    enabled: computed(() => !!payload.value),
  });
}
